<script>
import OwTable from '@/components/common/OwTable';
import TableRow from '@/components/courses/TableRow';

export default {
    name: 'CoursesTable',
    extends: OwTable,
    props: {
        headers: {
            type: Array,
            default: () => [
                'id', 'club_name', 'country', 'created_at', 'updated_at',
            ],
        },
        tableRowComponent: {
            type: Object,
            default: () => TableRow,
        },
    },
};
</script>
